import { getBaseUrl, request } from 'src/helper/api';
import { ONBOARDING_LOOKUP } from 'src/views/VendorPortal/Onboarding/constants';

const getLookUpData = (token?: string, lookupType?: string[] | string, usage?: string) =>
  request(
    {
      method: 'GET',
      url:
        usage !== ONBOARDING_LOOKUP
          ? `${getBaseUrl()}api/lookup/${lookupType}`
          : `${getBaseUrl()}api/vendor-onboarding/lookup/${lookupType}`,
      contentType: 'json',
      token,
    },
    'list-view/getLookUpData',
  );

export default getLookUpData;
